import React, {useState} from 'react'
import clsx from 'clsx'
import {makeStyles} from '@material-ui/core/styles'
import {CssBaseline} from '@material-ui/core'
import EventCategory from './EventSetupHome/EventCategory'
import EventOccurrence from './EventSetupHome/EventOccurrence'
import {dataConstants} from '../../constants'
import withEventSetupData from '../../components/withEventSetupData'

// using hook API
const useStyles = makeStyles(theme => ({
    root: {
        marginTop: '3.3rem',
        display: 'flex',
        height: '93vh',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: 'calc(100% - 25rem)',
        maxHeight: '93vh',
        overflowY: 'auto',
    },
    contentShift: {
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
}))

const EventSetupHome = props => {
    const classes = useStyles()
    const [open, setOpen] = useState(true)

    const {props: childProps} = props
    const {eventcategorylist, eventcategory} = childProps

    const handleDrawerOpen = () => {
        setOpen(true)
    }

    const handleDrawerClose = () => {
        setOpen(false)
    }

    return (
        <>
            <CssBaseline />
            <div className={classes.root}>
                <EventCategory
                    open={open}
                    handleDrawerOpen={handleDrawerOpen}
                    handleDrawerClose={handleDrawerClose}
                    eventcategorylist={eventcategorylist}
                    eventcategory={eventcategory}
                />
                <main
                    className={clsx(classes.content, {
                        [classes.contentShift]: open,
                    })}
                >
                    <EventOccurrence />
                </main>
            </div>
        </>
    )
}

const fetchrequests = [
    dataConstants.EVENT_CATEGORIES,
    dataConstants.EVENT_ENGAGEMENTTYPES,
    dataConstants.EVENT_SWIPETEAMS,
]

export default withEventSetupData(EventSetupHome, fetchrequests)
